<div class="col-12 billet-quick-component gridster-ignore-drag">
  <div class="row">
    <app-book-aggregated class="col-12 p-0" id="book-aggregated-component-{{ cardId }}"   [symbol]="symbol" [maxLine]="maxLine" [componentName]="componentName"
      [isSubscribeBook]="isSubscribeBook">
    </app-book-aggregated>
  </div>
  <div class="row sized" [ngClass]="{'theory': model.auctionHammer}">
    <div class="col-6 p-0 pad-r">
      <app-incremental-input-small [withBackground]="true" placeholder="Quantidade" name="model.qtd"
        ondragstart="return false;" ondrop="return false;" [roundLot]="model.loteDefault" maxlength="7"
        (mousewheel)="verifyQuantity()" [invalid]="qtdValid" minValue="0" maxValue="999999"
        (keydown)="validPrice(model.qtd)" (keyup)="verifyQuantity();validPrice(model.qtd);" (click)="verifyQuantity()"
        [isQuantity]="true" [(ngModel)]="model.qtd" aria-required="" [price]="false" [isDisabled]="!quantityDisabled()">
      </app-incremental-input-small>
    </div>
    <div class="col-6 p-0 pad-l">
      <app-incremental-input [withBackground]="true" name="model.price" ondragstart="return false;"
        ondrop="return false;" id="preço" placeholder="Preço" (valueChanged)="validPrice(model.price);verifyQuantity()"
        [options]="model.indiceFuture ? priceValuesFormatOptionsFuture : priceValuesFormatOptions"
        [roundLot]="this.model.minimumIncrement" minValue="0" maxValue="999999" [isQuantity]="true" [price]="true"
        [(ngModel)]="model.price" aria-required="" (keyup)="verifyQuantity()" [minValue]="0"
        (keyup)="validPrice(model.price)">
      </app-incremental-input>
    </div>
  </div>
  <div class="row">
    <app-billet-actions class="col-12" (actionConfirm)="confirmTradeAction($event)" [statusOmsOnline]="statusOmsOnline"
      [isLoggedNegotiation]="isLoggedNegotiation" [termOperator]="termOperator" [positionNetDay]="listPosition?.netDay"
      [asset]="model?.quote" [market]="model?.market" (openConfirmationBillit)="openModalConfirm($event)">
    </app-billet-actions>
  </div>
</div>
